/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { TabPanel, __experimentalDivider as Divider, __experimentalUnitControl as UnitControl, __experimentalNumberControl as NumberControl } from '@wordpress/components';
import { addFilter, applyFilters } from '@wordpress/hooks';

/**
 * External dependencies
 */
import { has } from 'lodash';

/**
 * Inner dependencies.
 */
import {
	ColorControl,
	GradientColorControl,
} from '../../../extensions/controls/color-options';
// import { updateBlockStyle } from '../inline-styles';
import Accordion from '../../../components/Accordion';
import BoxShadowControl from '../../../components/box-shadow-control';
import PaddingControl from '../../../components/padding-control';

import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-style`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/style`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { blockAdvanceOptions } = attributes;
		const { innerBlock } = blockAdvanceOptions;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'post-wrapper',
						initialOpen: true,
						label: () => {
							return __( 'Post style' );
						},
						cb: () => {
							return <>
								<TabPanel
									className="gutenify-editor-tab-panel gutenify-editor-tab-ovel"
									activeClass="active-tab"
									tabs={ [
										{
											name: 'normal',
											title: __( 'Normal' ),
											className: 'gutenify-color-normal-tab',
										},
										{
											name: 'hover',
											title: __( 'Hover' ),
											className: 'gutenify-color-hover-tab',
										},
									] }
								>
									{ ( tabInner ) => {
										return (
											<>
												{ 'normal' === tabInner.name && (
													<>
														<ColorControl
															label={ __( 'Color' ) }
															onChange={ ( val ) => {
																const data = {
																	blockAdvanceOptions: {
																		...blockAdvanceOptions,
																		innerBlock: {
																			...innerBlock,
																			textColor: val,
																		},
																	},
																};
																setAttributes( data );
																// updateBlockStyle( data, props );
															} }
															value={ has( blockAdvanceOptions, 'innerBlock.textColor' ) && blockAdvanceOptions.innerBlock.textColor ? blockAdvanceOptions.innerBlock.textColor : '' }
														/>
														<GradientColorControl
															label={ __( 'Background Color' ) }
															colorValue={ has( blockAdvanceOptions, 'innerBlock.backgroundColor' ) && blockAdvanceOptions.innerBlock.backgroundColor ? blockAdvanceOptions.innerBlock.backgroundColor : '' }
															gradientValue={ has( blockAdvanceOptions, 'innerBlock.backgroundGradient' ) && blockAdvanceOptions.innerBlock.backgroundGradient ? blockAdvanceOptions.innerBlock.backgroundGradient : '' }
															onChange={ ( val ) => {
																const data = {
																	blockAdvanceOptions: {
																		...blockAdvanceOptions,
																		innerBlock: {
																			...innerBlock,
																			...val,
																		},
																	},
																};
																setAttributes( data );
																// updateBlockStyle( data, props );
															} }
														/>
														<ColorControl
															label={ __( 'Border Color' ) }
															onChange={ ( val ) => {
																const data = {
																	blockAdvanceOptions: {
																		...blockAdvanceOptions,
																		innerBlock: {
																			...innerBlock,
																			borderColor: val,
																		},
																	},
																};
																setAttributes( data );
																// updateBlockStyle( data, props );
															} }
															value={ has( blockAdvanceOptions, 'innerBlock.borderColor' ) && blockAdvanceOptions.innerBlock.borderColor ? blockAdvanceOptions.innerBlock.borderColor : '' }
														/>
													</>
												) }
												{ 'hover' === tabInner.name && (
													<>
														<ColorControl
															label={ __( 'Color' ) }
															onChange={ ( val ) => {
																const data = {
																	blockAdvanceOptions: {
																		...blockAdvanceOptions,
																		innerBlock: {
																			...innerBlock,
																			hoverTextColor: val,
																		},
																	},
																};
																setAttributes( data );
																// updateBlockStyle( data, props );
															} }
															value={ has( blockAdvanceOptions, 'innerBlock.hoverTextColor' ) && blockAdvanceOptions.innerBlock.hoverTextColor ? blockAdvanceOptions.innerBlock.hoverTextColor : '' }
														/>
														<GradientColorControl
															label={ __( 'Background Color' ) }
															colorValue={ has( blockAdvanceOptions, 'innerBlock.hoverBackgroundColor' ) && blockAdvanceOptions.innerBlock.hoverBackgroundColor ? blockAdvanceOptions.innerBlock.hoverBackgroundColor : '' }
															gradientValue={
																has( blockAdvanceOptions, 'innerBlock.hoverBackgroundGradient' ) && blockAdvanceOptions.innerBlock.hoverBackgroundGradient ? blockAdvanceOptions.innerBlock.hoverBackgroundGradient : ''
															}
															onChange={ ( val ) => {
																const data = {
																	blockAdvanceOptions: {
																		...blockAdvanceOptions,
																		innerBlock: {
																			...innerBlock,
																			...{
																				hoverBackgroundColor: val.backgroundColor,
																				hoverBackgroundGradient: val.backgroundGradient,
																			},
																		},
																	},
																};
																setAttributes( data );
																// updateBlockStyle( data, props );
															} }
														/>
														<ColorControl
															label={ __( 'Border Color' ) }
															onChange={ ( color ) => {
																const data = {
																	blockAdvanceOptions: {
																		...blockAdvanceOptions,
																		innerBlock: {
																			...innerBlock,
																			hoverBorderColor: color,
																		},
																	},
																};
																setAttributes( data );
																// updateBlockStyle( data, props );
															} }
															value={ has( blockAdvanceOptions, 'innerBlock.hoverBorderColor' ) && blockAdvanceOptions.innerBlock.hoverBorderColor ? blockAdvanceOptions.innerBlock.hoverBorderColor : '' }
														/>
													</>
												) }
												{ applyFilters( `gutenify--${ hookPrefix }--inspector--tab-style--posts`, [], props ) }
												<NumberControl
													label={ __( 'Border Width' ) }
													value={ has( blockAdvanceOptions, 'innerBlock.borderWidth' ) && blockAdvanceOptions.innerBlock.borderWidth }
													onChange={ ( val ) => {
														const data = {
															blockAdvanceOptions: {
																...blockAdvanceOptions,
																innerBlock: {
																	...innerBlock,
																	borderWidth: val,
																},
															},
														};
														setAttributes( data );
														// updateBlockStyle( data, props );
													} }
													min={ 0 }
													max={ 300 }
													// withInputField={ true }
												/>

												<UnitControl
													label={ __( 'Border Radius' ) }
													value={ has( blockAdvanceOptions, 'innerBlock.borderRadius' ) && blockAdvanceOptions.innerBlock.borderRadius }
													onChange={ ( val ) => {
														const data = {
															blockAdvanceOptions: {
																...blockAdvanceOptions,
																innerBlock: {
																	...innerBlock,
																	borderRadius: val,
																},
															},
														};
														setAttributes( data );
														// updateBlockStyle( data, props );
													} }
													min={ 0 }
													max={ 300 }
													// withInputField={ true }
												/>
												<UnitControl
													label={ __( 'Thumbnail Min Height' ) }
													value={ blockAdvanceOptions?.innerBlock?.thumbnailMinHeight && blockAdvanceOptions.innerBlock.thumbnailMinHeight }
													onChange={ ( val ) => {
														const data = {
															blockAdvanceOptions: {
																...blockAdvanceOptions,
																innerBlock: {
																	...innerBlock,
																	thumbnailMinHeight: val,
																},
															},
														};
														setAttributes( data );
													} }
													min={ 0 }
													// max={ 300 }
													// withInputField={ true }
													disableUnits={ true }
												/>
												<BoxShadowControl label={ __( 'Box Shadow' ) } value={ blockAdvanceOptions?.innerBlock?.boxShadow } onChange={ ( val ) => {
													const data = {
														blockAdvanceOptions: {
															...blockAdvanceOptions,
															innerBlock: {
																...innerBlock,
																boxShadow: val,
															},
														},
													};
													setAttributes( data );
												} } />
												<PaddingControl
													label={ __( 'Content Box Padding' ) }
													value={ blockAdvanceOptions?.innerBlock?.contentPadding ? blockAdvanceOptions.innerBlock.contentPadding : {} }
													onChange={ ( val ) => {
														const data = {
															blockAdvanceOptions: {
																...blockAdvanceOptions,
																innerBlock: {
																	...innerBlock,
																	contentPadding: val,
																},
															},
														};
														setAttributes( data );
													} }
												/>
												<Divider />
											</>
										);
									} }
								</TabPanel>
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);

